import { InitializerEvents } from "@ailenax-overlay/shared";
import { useSocket } from "./useSocket";
import { useEffect, useMemo } from "react";

export const useSocketCallback = <E extends keyof InitializerEvents>(eventName: E, ...params: Parameters<InitializerEvents[E]>) => {
    const socket = useSocket();

    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const stableParams = useMemo(() => params, params);

    useEffect(() => {
        socket.emit(eventName, ...stableParams);
    }, [socket, eventName, stableParams]);
    return eventName;
}